export default "__VITE_ASSET__b8b1c9a6__"